"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSnapshotSourceChannelName = void 0;
const channelPrefix = 'snapshot-source-provider-';
const getSnapshotSourceChannelName = (id) => `${channelPrefix}${id.uuid}`;
exports.getSnapshotSourceChannelName = getSnapshotSourceChannelName;
